"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/merchant.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fmerchant.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.recurringPaymentCadenceToJSON = exports.recurringPaymentCadenceFromJSON = exports.RecurringPayment = exports.MerchantOverridesByNameEntry = exports.MerchantOverrides = exports.MerchantReportedLocation = exports.MerchantAddress = exports.MerchantContactInfo = exports.Merchant = exports.MerchantPreview = exports.MerchantDescriptor = exports.RecurringPaymentCadence = void 0;
const geo_location_1 = require("./geo-location");
const protobufPackage = 'com.step.common.proto';
var RecurringPaymentCadence;
(function (RecurringPaymentCadence) {
    RecurringPaymentCadence["INVALID_CADENCE"] = "INVALID_CADENCE";
    RecurringPaymentCadence["MONTHLY"] = "MONTHLY";
    RecurringPaymentCadence["UNRECOGNIZED"] = "UNRECOGNIZED";
})(RecurringPaymentCadence || (exports.RecurringPaymentCadence = RecurringPaymentCadence = {}));
function createBaseMerchantDescriptor() {
    return {
        name: '',
        category: '',
        networkId: '',
        city: '',
        state: '',
        postalCode: '',
        country: '',
        url: '',
    };
}
exports.MerchantDescriptor = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.name)) {
            message.name = globalThis.String(object.name);
        }
        if (isSet(object.category)) {
            message.category = globalThis.String(object.category);
        }
        if (isSet(object.networkId)) {
            message.networkId = globalThis.String(object.networkId);
        }
        if (isSet(object.city)) {
            message.city = globalThis.String(object.city);
        }
        if (isSet(object.state)) {
            message.state = globalThis.String(object.state);
        }
        if (isSet(object.postalCode)) {
            message.postalCode = globalThis.String(object.postalCode);
        }
        if (isSet(object.country)) {
            message.country = globalThis.String(object.country);
        }
        if (isSet(object.url)) {
            message.url = globalThis.String(object.url);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== undefined && message.name !== '') {
            obj.name = message.name;
        }
        if (message.category !== undefined && message.category !== '') {
            obj.category = message.category;
        }
        if (message.networkId !== undefined && message.networkId !== '') {
            obj.networkId = message.networkId;
        }
        if (message.city !== undefined && message.city !== '') {
            obj.city = message.city;
        }
        if (message.state !== undefined && message.state !== '') {
            obj.state = message.state;
        }
        if (message.postalCode !== undefined && message.postalCode !== '') {
            obj.postalCode = message.postalCode;
        }
        if (message.country !== undefined && message.country !== '') {
            obj.country = message.country;
        }
        if (message.url !== undefined && message.url !== '') {
            obj.url = message.url;
        }
        return obj;
    },
    create(base) {
        return exports.MerchantDescriptor.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchantDescriptor();
        message.name = object.name ?? '';
        message.category = object.category ?? '';
        message.networkId = object.networkId ?? '';
        message.city = object.city ?? '';
        message.state = object.state ?? '';
        message.postalCode = object.postalCode ?? '';
        message.country = object.country ?? '';
        message.url = object.url ?? '';
        return message;
    },
};
function createBaseMerchantPreview() {
    return {
        locationId: '',
        name: '',
        category: '',
        logoUrl: '',
        backgroundImageUrl: '',
        isBlockable: false,
        enrichedId: '',
    };
}
exports.MerchantPreview = {
    fromJSON(object) {
        const message = {
            locationId: isSet(object.locationId) ? globalThis.String(object.locationId) : '',
            name: isSet(object.name) ? globalThis.String(object.name) : '',
            category: isSet(object.category) ? globalThis.String(object.category) : '',
            isBlockable: isSet(object.isBlockable) ? globalThis.Boolean(object.isBlockable) : false,
        };
        if (isSet(object.logoUrl)) {
            message.logoUrl = globalThis.String(object.logoUrl);
        }
        if (isSet(object.backgroundImageUrl)) {
            message.backgroundImageUrl = globalThis.String(object.backgroundImageUrl);
        }
        if (isSet(object.enrichedId)) {
            message.enrichedId = globalThis.String(object.enrichedId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.locationId !== '') {
            obj.locationId = message.locationId;
        }
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.category !== '') {
            obj.category = message.category;
        }
        if (message.logoUrl !== undefined && message.logoUrl !== '') {
            obj.logoUrl = message.logoUrl;
        }
        if (message.backgroundImageUrl !== undefined && message.backgroundImageUrl !== '') {
            obj.backgroundImageUrl = message.backgroundImageUrl;
        }
        if (message.isBlockable !== false) {
            obj.isBlockable = message.isBlockable;
        }
        if (message.enrichedId !== undefined && message.enrichedId !== '') {
            obj.enrichedId = message.enrichedId;
        }
        return obj;
    },
    create(base) {
        return exports.MerchantPreview.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchantPreview();
        message.locationId = object.locationId ?? '';
        message.name = object.name ?? '';
        message.category = object.category ?? '';
        message.logoUrl = object.logoUrl ?? '';
        message.backgroundImageUrl = object.backgroundImageUrl ?? '';
        message.isBlockable = object.isBlockable ?? false;
        message.enrichedId = object.enrichedId ?? '';
        return message;
    },
};
function createBaseMerchant() {
    return {
        name: '',
        category: '',
        logoUrl: '',
        backgroundImageUrl: '',
        address: undefined,
        coordinates: undefined,
        contactInfo: undefined,
        isBlockable: false,
        enrichedId: '',
        referenceId: '',
        referenceName: '',
    };
}
exports.Merchant = {
    fromJSON(object) {
        const message = {
            name: isSet(object.name) ? globalThis.String(object.name) : '',
            category: isSet(object.category) ? globalThis.String(object.category) : '',
            isBlockable: isSet(object.isBlockable) ? globalThis.Boolean(object.isBlockable) : false,
        };
        if (isSet(object.logoUrl)) {
            message.logoUrl = globalThis.String(object.logoUrl);
        }
        if (isSet(object.backgroundImageUrl)) {
            message.backgroundImageUrl = globalThis.String(object.backgroundImageUrl);
        }
        if (isSet(object.address)) {
            message.address = exports.MerchantAddress.fromJSON(object.address);
        }
        if (isSet(object.coordinates)) {
            message.coordinates = geo_location_1.GeoLocation.fromJSON(object.coordinates);
        }
        if (isSet(object.contactInfo)) {
            message.contactInfo = exports.MerchantContactInfo.fromJSON(object.contactInfo);
        }
        if (isSet(object.enrichedId)) {
            message.enrichedId = globalThis.String(object.enrichedId);
        }
        if (isSet(object.referenceId)) {
            message.referenceId = globalThis.String(object.referenceId);
        }
        if (isSet(object.referenceName)) {
            message.referenceName = globalThis.String(object.referenceName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.category !== '') {
            obj.category = message.category;
        }
        if (message.logoUrl !== undefined && message.logoUrl !== '') {
            obj.logoUrl = message.logoUrl;
        }
        if (message.backgroundImageUrl !== undefined && message.backgroundImageUrl !== '') {
            obj.backgroundImageUrl = message.backgroundImageUrl;
        }
        if (message.address !== undefined) {
            obj.address = exports.MerchantAddress.toJSON(message.address);
        }
        if (message.coordinates !== undefined) {
            obj.coordinates = geo_location_1.GeoLocation.toJSON(message.coordinates);
        }
        if (message.contactInfo !== undefined) {
            obj.contactInfo = exports.MerchantContactInfo.toJSON(message.contactInfo);
        }
        if (message.isBlockable !== false) {
            obj.isBlockable = message.isBlockable;
        }
        if (message.enrichedId !== undefined && message.enrichedId !== '') {
            obj.enrichedId = message.enrichedId;
        }
        if (message.referenceId !== undefined && message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        if (message.referenceName !== undefined && message.referenceName !== '') {
            obj.referenceName = message.referenceName;
        }
        return obj;
    },
    create(base) {
        return exports.Merchant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchant();
        message.name = object.name ?? '';
        message.category = object.category ?? '';
        message.logoUrl = object.logoUrl ?? '';
        message.backgroundImageUrl = object.backgroundImageUrl ?? '';
        message.address = (object.address !== undefined && object.address !== null)
            ? exports.MerchantAddress.fromPartial(object.address)
            : undefined;
        message.coordinates = (object.coordinates !== undefined && object.coordinates !== null)
            ? geo_location_1.GeoLocation.fromPartial(object.coordinates)
            : undefined;
        message.contactInfo = (object.contactInfo !== undefined && object.contactInfo !== null)
            ? exports.MerchantContactInfo.fromPartial(object.contactInfo)
            : undefined;
        message.isBlockable = object.isBlockable ?? false;
        message.enrichedId = object.enrichedId ?? '';
        message.referenceId = object.referenceId ?? '';
        message.referenceName = object.referenceName ?? '';
        return message;
    },
};
function createBaseMerchantContactInfo() {
    return { website: '', phone: '', email: '', facebook: '', twitter: '', instagram: '', yelp: '' };
}
exports.MerchantContactInfo = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.website)) {
            message.website = globalThis.String(object.website);
        }
        if (isSet(object.phone)) {
            message.phone = globalThis.String(object.phone);
        }
        if (isSet(object.email)) {
            message.email = globalThis.String(object.email);
        }
        if (isSet(object.facebook)) {
            message.facebook = globalThis.String(object.facebook);
        }
        if (isSet(object.twitter)) {
            message.twitter = globalThis.String(object.twitter);
        }
        if (isSet(object.instagram)) {
            message.instagram = globalThis.String(object.instagram);
        }
        if (isSet(object.yelp)) {
            message.yelp = globalThis.String(object.yelp);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.website !== undefined && message.website !== '') {
            obj.website = message.website;
        }
        if (message.phone !== undefined && message.phone !== '') {
            obj.phone = message.phone;
        }
        if (message.email !== undefined && message.email !== '') {
            obj.email = message.email;
        }
        if (message.facebook !== undefined && message.facebook !== '') {
            obj.facebook = message.facebook;
        }
        if (message.twitter !== undefined && message.twitter !== '') {
            obj.twitter = message.twitter;
        }
        if (message.instagram !== undefined && message.instagram !== '') {
            obj.instagram = message.instagram;
        }
        if (message.yelp !== undefined && message.yelp !== '') {
            obj.yelp = message.yelp;
        }
        return obj;
    },
    create(base) {
        return exports.MerchantContactInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchantContactInfo();
        message.website = object.website ?? '';
        message.phone = object.phone ?? '';
        message.email = object.email ?? '';
        message.facebook = object.facebook ?? '';
        message.twitter = object.twitter ?? '';
        message.instagram = object.instagram ?? '';
        message.yelp = object.yelp ?? '';
        return message;
    },
};
function createBaseMerchantAddress() {
    return {
        line1: '',
        line2: '',
        city: '',
        stateProvinceRegion: '',
        zipPostalCode: '',
        country: '',
    };
}
exports.MerchantAddress = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.line1)) {
            message.line1 = globalThis.String(object.line1);
        }
        if (isSet(object.line2)) {
            message.line2 = globalThis.String(object.line2);
        }
        if (isSet(object.city)) {
            message.city = globalThis.String(object.city);
        }
        if (isSet(object.stateProvinceRegion)) {
            message.stateProvinceRegion = globalThis.String(object.stateProvinceRegion);
        }
        if (isSet(object.zipPostalCode)) {
            message.zipPostalCode = globalThis.String(object.zipPostalCode);
        }
        if (isSet(object.country)) {
            message.country = globalThis.String(object.country);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.line1 !== undefined && message.line1 !== '') {
            obj.line1 = message.line1;
        }
        if (message.line2 !== undefined && message.line2 !== '') {
            obj.line2 = message.line2;
        }
        if (message.city !== undefined && message.city !== '') {
            obj.city = message.city;
        }
        if (message.stateProvinceRegion !== undefined && message.stateProvinceRegion !== '') {
            obj.stateProvinceRegion = message.stateProvinceRegion;
        }
        if (message.zipPostalCode !== undefined && message.zipPostalCode !== '') {
            obj.zipPostalCode = message.zipPostalCode;
        }
        if (message.country !== undefined && message.country !== '') {
            obj.country = message.country;
        }
        return obj;
    },
    create(base) {
        return exports.MerchantAddress.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchantAddress();
        message.line1 = object.line1 ?? '';
        message.line2 = object.line2 ?? '';
        message.city = object.city ?? '';
        message.stateProvinceRegion = object.stateProvinceRegion ?? '';
        message.zipPostalCode = object.zipPostalCode ?? '';
        message.country = object.country ?? '';
        return message;
    },
};
function createBaseMerchantReportedLocation() {
    return {
        locationId: '',
        userId: '',
        paymentId: '',
        transactedAtMs: '0',
        reportedAtMs: '0',
        createdAtMs: '0',
        geolocation: geo_location_1.UserGeolocation.fromPartial({}),
    };
}
exports.MerchantReportedLocation = {
    fromJSON(object) {
        const message = {
            locationId: isSet(object.locationId) ? globalThis.String(object.locationId) : '',
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            paymentId: isSet(object.paymentId) ? globalThis.String(object.paymentId) : '',
            transactedAtMs: isSet(object.transactedAtMs) ? globalThis.String(object.transactedAtMs) : '0',
            reportedAtMs: isSet(object.reportedAtMs) ? globalThis.String(object.reportedAtMs) : '0',
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
            geolocation: isSet(object.geolocation)
                ? geo_location_1.UserGeolocation.fromJSON(object.geolocation)
                : geo_location_1.UserGeolocation.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.locationId !== '') {
            obj.locationId = message.locationId;
        }
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.paymentId !== '') {
            obj.paymentId = message.paymentId;
        }
        if (message.transactedAtMs !== '0') {
            obj.transactedAtMs = message.transactedAtMs;
        }
        if (message.reportedAtMs !== '0') {
            obj.reportedAtMs = message.reportedAtMs;
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.geolocation !== undefined) {
            obj.geolocation = geo_location_1.UserGeolocation.toJSON(message.geolocation);
        }
        return obj;
    },
    create(base) {
        return exports.MerchantReportedLocation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchantReportedLocation();
        message.locationId = object.locationId ?? '';
        message.userId = object.userId ?? '';
        message.paymentId = object.paymentId ?? '';
        message.transactedAtMs = object.transactedAtMs ?? '0';
        message.reportedAtMs = object.reportedAtMs ?? '0';
        message.createdAtMs = object.createdAtMs ?? '0';
        message.geolocation = (object.geolocation !== undefined && object.geolocation !== null)
            ? geo_location_1.UserGeolocation.fromPartial(object.geolocation)
            : geo_location_1.UserGeolocation.fromPartial({});
        return message;
    },
};
function createBaseMerchantOverrides() {
    return { byName: {} };
}
exports.MerchantOverrides = {
    fromJSON(object) {
        const message = {
            byName: isObject(object.byName)
                ? Object.entries(object.byName).reduce((acc, [key, value]) => {
                    acc[key] = exports.Merchant.fromJSON(value);
                    return acc;
                }, {})
                : {},
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.byName) {
            const entries = Object.entries(message.byName);
            if (entries.length > 0) {
                obj.byName = {};
                entries.forEach(([k, v]) => {
                    obj.byName[k] = exports.Merchant.toJSON(v);
                });
            }
        }
        return obj;
    },
    create(base) {
        return exports.MerchantOverrides.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchantOverrides();
        message.byName = Object.entries(object.byName ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = exports.Merchant.fromPartial(value);
            }
            return acc;
        }, {});
        return message;
    },
};
function createBaseMerchantOverridesByNameEntry() {
    return { key: '', value: undefined };
}
exports.MerchantOverridesByNameEntry = {
    fromJSON(object) {
        const message = {
            key: isSet(object.key) ? globalThis.String(object.key) : '',
        };
        if (isSet(object.value)) {
            message.value = exports.Merchant.fromJSON(object.value);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = exports.Merchant.toJSON(message.value);
        }
        return obj;
    },
    create(base) {
        return exports.MerchantOverridesByNameEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchantOverridesByNameEntry();
        message.key = object.key ?? '';
        message.value = (object.value !== undefined && object.value !== null)
            ? exports.Merchant.fromPartial(object.value)
            : undefined;
        return message;
    },
};
function createBaseRecurringPayment() {
    return { cadence: RecurringPaymentCadence.INVALID_CADENCE };
}
exports.RecurringPayment = {
    fromJSON(object) {
        const message = {
            cadence: isSet(object.cadence)
                ? recurringPaymentCadenceFromJSON(object.cadence)
                : RecurringPaymentCadence.INVALID_CADENCE,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cadence !== RecurringPaymentCadence.INVALID_CADENCE) {
            obj.cadence = recurringPaymentCadenceToJSON(message.cadence);
        }
        return obj;
    },
    create(base) {
        return exports.RecurringPayment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRecurringPayment();
        message.cadence = object.cadence ?? RecurringPaymentCadence.INVALID_CADENCE;
        return message;
    },
};
function recurringPaymentCadenceFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CADENCE':
            return RecurringPaymentCadence.INVALID_CADENCE;
        case 1:
        case 'MONTHLY':
            return RecurringPaymentCadence.MONTHLY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return RecurringPaymentCadence.UNRECOGNIZED;
    }
}
exports.recurringPaymentCadenceFromJSON = recurringPaymentCadenceFromJSON;
function recurringPaymentCadenceToJSON(object) {
    switch (object) {
        case RecurringPaymentCadence.INVALID_CADENCE:
            return 'INVALID_CADENCE';
        case RecurringPaymentCadence.MONTHLY:
            return 'MONTHLY';
        case RecurringPaymentCadence.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.recurringPaymentCadenceToJSON = recurringPaymentCadenceToJSON;
function isObject(value) {
    return typeof value === 'object' && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=merchant.js.map